var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarker = function SvgMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66667 0C9.06667 0 11.3333 2.42662 11.3333 6.06654C11.3333 8.20945 9.8603 10.6678 6.91423 13.4415C6.21339 14.1013 5.11995 14.1013 4.41912 13.4415L4.1196 13.1557C1.3732 10.4986 0 8.13556 0 6.06654C0 2.42662 2.26667 0 5.66667 0ZM5.66667 3.54167C4.49306 3.54167 3.54167 4.49306 3.54167 5.66667C3.54167 6.84027 4.49306 7.79167 5.66667 7.79167C6.84027 7.79167 7.79167 6.84027 7.79167 5.66667C7.79167 4.49306 6.84027 3.54167 5.66667 3.54167Z",
    fill: "#343A40"
  })));
};
export default SvgMarker;